<div class="container px-2 mb-3">
  <div class="row my-1">
    <div class="col-12 dCenter justify-content-start">
      @if (showPaymentGateways || showStripeForm) {
        <fa-icon
          class="cursor me-3"
          [icon]="faArrowLeft"
          (click)="showPaymentGateways ? GoBackPage1() : GoBackPage2()"
        ></fa-icon>
      }
      <h4 class="gilroy-b mb-0">Show Appreciation</h4>
    </div>
  </div>
  @if (showSupportDetails) {
    <div>
      <div class="row">
        <div class="col-12 p-2">
          <div class="container rounded-4 bg-light">
            <div class="row mt-3 mb-3">
              <div
                class="align-items-end col-12 d-flex justify-content-center mt-5"
              >
                <fa-icon
                  [icon]="faMugHot"
                  size="4x"
                  style="color: #7c7c7d"
                ></fa-icon>
                <h4 class="gilroy-b gilroy-b opacity-50 text-black ms-3">
                  = {{ perCoffeePrice | currency: "USD" }} USD
                </h4>
              </div>
            </div> 
            <div class="row mb-3">
              <div class="col-12 d-flex justify-content-center">
                <h6>Select Quantity Of Coffee</h6>
              </div>
            </div>

            <div class="row gap-0 gap-lg-3 mb-3">
              <div class="col d-grid">
                <button
                  (click)="appendQuantity(1)"
                  [class.selected-col]="selectedButton === 1"
                  class="gilroy-b btn hover-col border-0 light-bg-col2 rounded-3"
                >
                  1
                </button>
              </div>
              <div class="col d-grid">
                <button
                  (click)="appendQuantity(3)"
                  [class.selected-col]="selectedButton === 3"
                  class="gilroy-b btn hover-col border-0 light-bg-col2 rounded-3"
                >
                  3
                </button>
              </div>
              <div class="col d-grid">
                <button
                  (click)="appendQuantity(5)"
                  [class.selected-col]="selectedButton === 5"
                  class="gilroy-b btn hover-col border-0 light-bg-col2 rounded-3"
                >
                  5
                </button>
              </div>

              <div
                class="col-1 d-grid align-items-center justify-content-evenly"
              >
                <h6 class="opacity-50 text-dark">Or</h6>
              </div>

              <div class="col d-grid">
                <input
                  [(ngModel)]="noOfCoffee"
                  (input)="appendQuantity($event)"
                  type="number"
                  class="rounded-3 qty border-0 text-center"
                  appCharacterLimit
                  [limit]="2"
                />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <textarea
                  class="form-control mb-3"
                  [(ngModel)]="description"
                  appCharacterLimit
                  [limit]="50"
                  id="exampleFormControlTextarea1"
                  rows="5"
                  placeholder="Say Something Nice..."
                ></textarea>
                <small class="text-black-50 float-end characterCounter ps-3">
                  {{
                    description?.trim().length > 0 ? description?.length : 0
                  }}/50</small
                >
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col d-grid">
              <button
                [disabled]="!noOfCoffee"
                (click)="openPaymentGateways()"
                class="btnPrimary gilroy-b rounded-3"
              >
                Appreciate Me {{ btnPrice | currency: "USD" }} USD
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showPaymentGateways) {
    <div class="sec-two">
      @if (!userDetails) {
        <div class="row">
          <div class="col-lg-12 my-1 text-center">
            <small
              >Please enter your email address and select payment method to move
              forward.</small
            >
          </div>
          <div class="col-lg-12 my-1">
            <app-input
              type="email"
              toolTip="Please enter your email address, for example, 'example@gmail.com'"
              [icon]="faAt"
              [form]="GuestForm"
              control="email"
              label="Email address"
              placeholder="Enter your email address"
            ></app-input>
          </div>
        </div>
      }
      <div class="row">
        <label class="col-12 my-1" for="flexRadioDefault1">
          <div class="light-bg-col py-3 rounded-4 hoverOption px-3">
            <input
              class="float-end top-0"
              (change)="onPaymentChange($event)"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              [value]="paymentTypes.Stripe"
            />
            <div class="mb-1">
              <fa-icon
                size="2x"
                style="color: #458ffd"
                [icon]="faCard"
              ></fa-icon>
            </div>
            <span class="gilroy-b text-primary opacity-75">
              Master/Visa Card
            </span>
          </div>
        </label>
        
        @if (isPaypalActive) {
          <label class="col-12 my-1" for="flexRadioDefault2">
            <div class="light-bg-col py-3 rounded-4 hoverOption px-3">
              <input
                class="float-end top-0"
                (change)="onPaymentChange($event)"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
                [value]="paymentTypes.PayPal"
              />
              <div class="mb-1">
                <fa-icon
                  size="2x"
                  style="color: #458ffd"
                  [icon]="faPayPal"
                ></fa-icon>
              </div>
              <span class="gilroy-b text-primary opacity-75"> Paypal </span>
            </div>
          </label>
        }
        @if (isWaleeActive && userDetails?.currentCountry == "pk") {
          <label class="col-12 my-1" for="flexRadioDefault3">
            <div class="light-bg-col py-3 rounded-4 hoverOption px-3">
              <input
                class="float-end top-0"
                (change)="onPaymentChange($event)"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault3"
                [value]="paymentTypes.JazzCash"
              />
              <div class="mb-1">
                <fa-icon
                  size="2x"
                  style="color: #458ffd"
                  [icon]="faWallet"
                ></fa-icon>
              </div>
              <span class="gilroy-b text-primary opacity-75">JazzCash</span>
            </div>
          </label>
        }
        @if (isEasyPaisaActive && userDetails?.currentCountry == "pk") {
          <label class="col-12 my-1" for="flexRadioDefault4">
            <div class="light-bg-col py-3 rounded-4 hoverOption px-3">
              <input
                class="float-end top-0"
                (change)="onPaymentChange($event)"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault4"
                [value]="paymentTypes.EasyPaisa"
              />
              <div class="mb-1">
                <fa-icon
                  size="2x"
                  style="color: #458ffd"
                  [icon]="faWallet"
                ></fa-icon>
              </div>
              <span class="gilroy-b text-primary opacity-75">EasyPaisa</span>
            </div>
          </label>
        }
        @if (isWalletActive) {
          <label class="col-12 my-1" for="flexRadioDefault4">
            <div class="light-bg-col py-3 rounded-4 hoverOption px-3">
              <input
                class="float-end top-0"
                (change)="onPaymentChange($event)"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault4"
                [value]="paymentTypes.Wallet"
              />
              <div class="mb-1">
                <fa-icon
                  size="2x"
                  style="color: #458ffd"
                  [icon]="faWallet"
                ></fa-icon>
              </div>
              <span class="gilroy-b text-primary opacity-75"> Wallet </span>
            </div>
          </label>
        }
        <div class="col-12 text-center">
          <button
            class="btnPrimary"
            [disabled]="!selectedPayment || (!userDetails && GuestForm.invalid)"
            (click)="continuePayment()"
          >
            Continue Payment
          </button>
        </div>
      </div>
    </div>
  }
  @if (showStripeForm) {
    <div class="sec-three">
      <div class="row mt-3 mb-5 mb-lg-2 mb-md-2">
        <div class="col-12">
          <app-stripe-form [stripeForm]="StripeModalForm"></app-stripe-form>
          <div class="row mt-3 mb-1">
            <div class="col d-grid">
              <button
                (click)="userDetails ? StripePayment() : guestUser('stripe')"
                class="btnPrimary gilroy-b rounded-3"
                [disabled]="!StripeModalForm.valid"
              >
                Pay {{ btnPrice | currency: "USD" }} USD
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
